import UserService from './services/user.service';
import ProjectsService from './services/projects.service';
import CreateAllocationsColumns from './useCases/capacities/createAllocationsColumns.useCase';
import CreateAllocationsRowData from './useCases/capacities/createAllocationsRowData.useCase';
import SortRowsByGrouping from './useCases/common/sortRowsByGrouping.useCase';
import CreateAllocationsPinnedTopRowData from './useCases/capacities/createAllocationsPinnedTopRowData.useCase';
import CapacitiesService from './services/capacities.service';
import TimesheetService from './services/timesheet.service';
import CreateTimesheetColumns from './useCases/timesheet/createTimesheetColumns.useCase';
import CreateTimesheetRowData from './useCases/timesheet/createTimesheetRowData.useCase';
import CreateTimesheetPinnedBottomRowData from './useCases/timesheet/createTimesheetPinnedBottomRowData.useCase';
import ValidatePaidSubscription from './useCases/subscription/validatePaidSubscription.useCase';
import EmployeeService from './services/employee.service';
import UpdateRowOnDragEnd from './useCases/common/updateRowOnDragEnd.useCase';
import CategoryService from './services/category.service';
import WorkReportService from './services/workReports.service';
import BillingService from './services/billing.service';

// services
const projectsService = new ProjectsService();
const userService = new UserService();
const capacitiesService = new CapacitiesService();
const timesheetService = new TimesheetService();
const employeeService = new EmployeeService();
const categoryService = new CategoryService();
const workReportsService = new WorkReportService();
const billingService = new BillingService();

// common use cases
const updateRowOnDragEnd = new UpdateRowOnDragEnd();
const sortRowsByGrouping = new SortRowsByGrouping();

// capacity use cases
const createAllocationsColumns = new CreateAllocationsColumns();
const createAllocationsRowData = new CreateAllocationsRowData();
const createAllocationsPinnedTopRowData = new CreateAllocationsPinnedTopRowData();

// timesheet use cases
const createTimesheetColumns = new CreateTimesheetColumns();
const createTimesheetRowData = new CreateTimesheetRowData();
const createTimesheetPinnedBottomRowData = new CreateTimesheetPinnedBottomRowData();

// subscription usecases
const validatePaidSubscription = new ValidatePaidSubscription();

export {
  projectsService,
  userService,
  capacitiesService,
  createAllocationsColumns,
  createAllocationsRowData,
  createAllocationsPinnedTopRowData,
  timesheetService,
  createTimesheetColumns,
  createTimesheetRowData,
  createTimesheetPinnedBottomRowData,
  employeeService,
  updateRowOnDragEnd,
  sortRowsByGrouping,
  categoryService,
  workReportsService,
  billingService,
  validatePaidSubscription
};
